import React from 'react'
import { useParams } from 'react-router-dom'
import { Formik, Form } from 'formik'

import {
  SuperMidWetSchema,
  initialSuperMidWetValues,
} from '../../utils/validation/superMidWet.js'
import { useSideNav } from '../../contexts/SideNavOpenContext.js'
import { useRecordLock } from '../../contexts/RecordLockContext'
import useSuperMid from '../../hooks/useSuperMid'

import ActionBar from '../shared/ActionBar.js'

import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import IconButton from '@mui/material/IconButton'

import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'

import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'

const SuperMidWet = () => {
  const { id } = useParams()
  const { sideNavOpen } = useSideNav(true)
  const { recordLock, setRecordLock } = useRecordLock()
  const { getSuperMidDraft, patchSuperMidWetDraft } = useSuperMid({ id })

  const handleSave = (values, { setSubmitting }) => {
    patchSuperMidWetDraft.mutate(values)
    setSubmitting(false)
    setRecordLock(true)
  }

  const handleDateChange = (name, value, values, setValues) => {
    setValues({ ...values, [name]: value })
  }

  const handleChange = (e, values, setValues) => {
    const name = e.target.name
    const value = e.target.value
    setValues({ ...values, [name]: value })
  }
  const handleChangeCheckbox = (name, values, setValues) => {
    values[name] === `Didn't Startup`
      ? setValues({ ...values, [name]: '' })
      : setValues({ ...values, [name]: `Didn't Startup` })
  }

  const calSiloTotals = (e, values, setValues) => {
    const name = e.target.name
    const value = e.target.value
    values = { ...values, [name]: value }

    let totalRawMilk = 0
    let totalSkimMilk = 0
    let totalRawCream = 0
    let totalPasteurizedCream = 0
    let totalPerm = 0
    let totalWater = 0
    let silos = []

    silos.push({ product: values.silo1Product, volume: values.silo1Volume })
    silos.push({ product: values.silo2Product, volume: values.silo2Volume })
    silos.push({ product: values.silo3Product, volume: values.silo3Volume })
    silos.push({ product: values.silo4Product, volume: values.silo4Volume })
    silos.push({ product: values.silo5Product, volume: values.silo5Volume })
    silos.push({ product: values.silo6Product, volume: values.silo6Volume })
    silos.push({ product: values.silo7Product, volume: values.silo7Volume })
    silos.push({ product: values.silo9Product, volume: values.silo9Volume })
    silos.push({ product: values.silo10Product, volume: values.silo10Volume })
    silos.push({ product: values.silo11Product, volume: values.silo11Volume })
    silos.push({ product: values.silo12Product, volume: values.silo12Volume })
    silos.push({ product: values.silo15Product, volume: values.silo15Volume })
    silos.push({ product: values.silo24Product, volume: values.silo24Volume })
    silos.push({ product: values.silo14Product, volume: values.silo14Volume })
    silos.push({ product: values.silo16Product, volume: values.silo16Volume })
    silos.push({ product: values.silo26Product, volume: values.silo26Volume })
    silos.push({ product: values.silo13Product, volume: values.silo13Volume })
    silos.push({ product: values.silo25Product, volume: values.silo25Volume })
    silos.push({ product: values.silo22Product, volume: values.silo22Volume })
    silos.push({ product: values.silo23Product, volume: values.silo23Volume })
    silos.push({ product: values.silo18Product, volume: values.silo18Volume })
    silos.push({ product: values.silo19Product, volume: values.silo19Volume })
    silos.push({ product: values.silo20Product, volume: values.silo20Volume })
    silos.push({ product: values.silo21Product, volume: values.silo21Volume })
    silos.push({ product: values.htstTnkProduct, volume: values.htstTnkVolume })
    silos.push({ product: values.evapTnkProduct, volume: values.evapTnkVolume })
    silos.push({
      product: values.recoveryTnkProduct,
      volume: values.recoveryTnkVolume,
    })

    silos.forEach((silo) => {
      if (silo.product === 'Raw Milk')
        return (totalRawMilk += parseInt(silo.volume) || 0)
      if (silo.product === 'Skim Milk')
        return (totalSkimMilk += parseInt(silo.volume) || 0)
      if (silo.product === 'Raw Cream')
        return (totalRawCream += parseInt(silo.volume) || 0)
      if (silo.product === 'Pasteurized Cream')
        return (totalPasteurizedCream += parseInt(silo.volume) || 0)
      if (silo.product === 'Permeate')
        return (totalPerm += parseInt(silo.volume) || 0)
      if (silo.product === 'Water')
        return (totalWater += parseInt(silo.volume) || 0)
    })

    values = {
      ...values,
      totalRawMilk,
      totalSkimMilk,
      totalRawCream,
      totalPasteurizedCream,
      totalPerm,
      totalWater,
    }

    setValues(values)
  }

  const calTotalButterPallets = (e, values, setValues) => {
    const name = e.target.name
    const value = e.target.value
    values = { ...values, [name]: value }

    let n1 = parseInt(values.butterPalletsProduced1) || 0
    let n2 = parseInt(values.butterPalletsProduced2) || 0
    let n3 = parseInt(values.butterPalletsProduced3) || 0

    values.butterTotalPalletsProduced = n1 + n2 + n3

    setValues(values)
  }
  return (
    <>
      <Formik
        initialValues={{
          ...initialSuperMidWetValues,
          ...getSuperMidDraft?.data,
        }}
        validationSchema={SuperMidWetSchema}
        onSubmit={(values, { setSubmitting }) =>
          handleSave(values, { setSubmitting })
        }
        enableReinitialize
      >
        {({
          isSubmitting,
          handleSubmit,
          values,
          touched,
          errors,
          setValues,
        }) => (
          <>
            <Form id={`SuperMidWet${id}`} onSubmit={handleSubmit}>
              <Grid
                container
                justifyContent='center'
                alignItems='center'
                sx={{
                  pl: sideNavOpen ? '260px' : '60px',
                  pt: '70px',
                  pr: '10px',
                  pb: '100px',
                }}
              >
                <Grid item xs={3}></Grid>
                <Grid item xs={9}>
                  <Typography variant='h1'>
                    Supervisor Mid Shift Passdown Wet Side
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Name
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='wetName'
                    disabled={true}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wetName}
                    error={touched.wetName && !!errors.wetName}
                    helperText={touched.wetName && errors.wetName}
                  />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={9}>
                  <span style={{ color: 'red' }}>
                    * Note: Wet and Dry Start Date and Shift must match in order
                    for email to be sent
                  </span>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Date Shift Started
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <DatePicker
                    name='wetDate'
                    disabled={recordLock}
                    onChange={(value) =>
                      handleDateChange('wetDate', value, values, setValues)
                    }
                    value={values.wetDate}
                    error={touched.wetDate && !!errors.wetDate}
                    helperText={touched.wetDate && errors.wetDate}
                    renderInput={(params) => (
                      <TextField fullWidth size='small' {...params} />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Shift
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='wetShift'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wetShift}
                    error={touched.wetShift && !!errors.wetShift}
                    helperText={touched.wetShift && errors.wetShift}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='A Day'>A Day</MenuItem>
                    <MenuItem value='A Night'>A Night</MenuItem>
                    <MenuItem value='B Day'>B Day</MenuItem>
                    <MenuItem value='B Night'>B Night</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Message From Sender
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    multiline
                    maxRows={Infinity}
                    name='wetMessage'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.wetMessage}
                    error={touched.wetMessage && !!errors.wetMessage}
                    helperText={touched.wetMessage && errors.wetMessage}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Bulk Chemicals
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>Ultrasil 110</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='ultrasil110'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.ultrasil110}
                    error={touched.ultrasil110 && !!errors.ultrasil110}
                    helperText={touched.ultrasil110 && errors.ultrasil110}
                  />
                </Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>AC-103 South</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='ac103South'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.ac103South}
                    error={touched.ac103South && !!errors.ac103South}
                    helperText={touched.ac103South && errors.ac103South}
                  />
                </Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>AC55-5</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='ac555'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.ac555}
                    error={touched.ac555 && !!errors.ac555}
                    helperText={touched.ac555 && errors.ac555}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    INTAKE
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Milk
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>Total Raw Milk </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='totalRawMilk'
                    disabled={true}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.totalRawMilk}
                    error={touched.totalRawMilk && !!errors.totalRawMilk}
                    helperText={touched.totalRawMilk && errors.totalRawMilk}
                  />
                </Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>Total Skim Milk</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='totalSkimMilk'
                    disabled={true}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.totalSkimMilk}
                    error={touched.totalSkimMilk && !!errors.totalSkimMilk}
                    helperText={touched.totalSkimMilk && errors.totalSkimMilk}
                  />
                </Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>Currently Filling Milk Silo #</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='currentlyFillingMilkSilo'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.currentlyFillingMilkSilo}
                    error={
                      touched.currentlyFillingMilkSilo &&
                      !!errors.currentlyFillingMilkSilo
                    }
                    helperText={
                      touched.currentlyFillingMilkSilo &&
                      errors.currentlyFillingMilkSilo
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Cream
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>Total Raw Cream</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='totalRawCream'
                    disabled={true}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.totalRawCream}
                    error={touched.totalRawCream && !!errors.totalRawCream}
                    helperText={touched.totalRawCream && errors.totalRawCream}
                  />
                </Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>Total Pasteurized Cream</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='totalPasteurizedCream'
                    disabled={true}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.totalPasteurizedCream}
                    error={
                      touched.totalPasteurizedCream &&
                      !!errors.totalPasteurizedCream
                    }
                    helperText={
                      touched.totalPasteurizedCream &&
                      errors.totalPasteurizedCream
                    }
                  />
                </Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>Currently Filling Cream Silo #</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='currenlyFillingCreamSilo'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.currenlyFillingCreamSilo}
                    error={
                      touched.currenlyFillingCreamSilo &&
                      !!errors.currenlyFillingCreamSilo
                    }
                    helperText={
                      touched.currenlyFillingCreamSilo &&
                      errors.currenlyFillingCreamSilo
                    }
                  />
                </Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>Total Perm</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='totalPerm'
                    disabled={true}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.totalPerm}
                    error={touched.totalPerm && !!errors.totalPerm}
                    helperText={touched.totalPerm && errors.totalPerm}
                  />
                </Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>
                    Silos Washed on Shift (List Silo Numbers)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silosWashed'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silosWashed}
                    error={touched.silosWashed && !!errors.silosWashed}
                    helperText={touched.silosWashed && errors.silosWashed}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    WET PROCESSING
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Milk
                  </Typography>
                </Grid>
                <Grid item xs={4.5}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    HTST 1
                  </Typography>
                </Grid>
                <Grid item xs={4.5}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    HTST 2
                  </Typography>
                </Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>Currently Pulling Milk Silo #</Typography>
                </Grid>
                <Grid item xs={4.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='htst1CurrentlyPullingMilkSilo'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.htst1CurrentlyPullingMilkSilo}
                    error={
                      touched.htst1CurrentlyPullingMilkSilo &&
                      !!errors.htst1CurrentlyPullingMilkSilo
                    }
                    helperText={
                      touched.htst1CurrentlyPullingMilkSilo &&
                      errors.htst1CurrentlyPullingMilkSilo
                    }
                  />
                </Grid>
                <Grid item xs={4.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='htst2CurrentlyPullingMilkSilo'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.htst2CurrentlyPullingMilkSilo}
                    error={
                      touched.htst2CurrentlyPullingMilkSilo &&
                      !!errors.htst2CurrentlyPullingMilkSilo
                    }
                    helperText={
                      touched.htst2CurrentlyPullingMilkSilo &&
                      errors.htst2CurrentlyPullingMilkSilo
                    }
                  />
                </Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>Currently Processing Milk at (lbs/hr)</Typography>
                </Grid>
                <Grid item xs={4.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='htst1CurrentlyProcessingMilkAt'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.htst1CurrentlyProcessingMilkAt}
                    error={
                      touched.htst1CurrentlyProcessingMilkAt &&
                      !!errors.htst1CurrentlyProcessingMilkAt
                    }
                    helperText={
                      touched.htst1CurrentlyProcessingMilkAt &&
                      errors.htst1CurrentlyProcessingMilkAt
                    }
                  />
                </Grid>
                <Grid item xs={4.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='htst2CurrentlyProcessingMilkAt'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.htst2CurrentlyProcessingMilkAt}
                    error={
                      touched.htst2CurrentlyProcessingMilkAt &&
                      !!errors.htst2CurrentlyProcessingMilkAt
                    }
                    helperText={
                      touched.htst2CurrentlyProcessingMilkAt &&
                      errors.htst2CurrentlyProcessingMilkAt
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Cream
                  </Typography>
                </Grid>
                <Grid item xs={4.5}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    HTST 1
                  </Typography>
                </Grid>
                <Grid item xs={4.5}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    HTST 2
                  </Typography>
                </Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>Currently Pulling Cream Silo #</Typography>
                </Grid>
                <Grid item xs={4.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='htst1CurrentlyPullingCreamSilo'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.htst1CurrentlyPullingCreamSilo}
                    error={
                      touched.htst1CurrentlyPullingCreamSilo &&
                      !!errors.htst1CurrentlyPullingCreamSilo
                    }
                    helperText={
                      touched.htst1CurrentlyPullingCreamSilo &&
                      errors.htst1CurrentlyPullingCreamSilo
                    }
                  />
                </Grid>
                <Grid item xs={4.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='htst2CurrentlyPullingCreamSilo'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.htst2CurrentlyPullingCreamSilo}
                    error={
                      touched.htst2CurrentlyPullingCreamSilo &&
                      !!errors.htst2CurrentlyPullingCreamSilo
                    }
                    helperText={
                      touched.htst2CurrentlyPullingCreamSilo &&
                      errors.htst2CurrentlyPullingCreamSilo
                    }
                  />
                </Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>
                    Currently Processing Cream at (lbs/hr)
                  </Typography>
                </Grid>
                <Grid item xs={4.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='htst1CurrentlyProcessingCreamAt'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.htst1CurrentlyProcessingCreamAt}
                    error={
                      touched.htst1CurrentlyProcessingCreamAt &&
                      !!errors.htst1CurrentlyProcessingCreamAt
                    }
                    helperText={
                      touched.htst1CurrentlyProcessingCreamAt &&
                      errors.htst1CurrentlyProcessingCreamAt
                    }
                  />
                </Grid>
                <Grid item xs={4.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='htst2CurrentlyProcessingCreamAt'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.htst2CurrentlyProcessingCreamAt}
                    error={
                      touched.htst2CurrentlyProcessingCreamAt &&
                      !!errors.htst2CurrentlyProcessingCreamAt
                    }
                    helperText={
                      touched.htst2CurrentlyProcessingCreamAt &&
                      errors.htst2CurrentlyProcessingCreamAt
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    CIP
                  </Typography>
                </Grid>
                <Grid item xs={4.5}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    HTST 1
                  </Typography>
                </Grid>
                <Grid item xs={4.5}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    HTST 2
                  </Typography>
                </Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>CIP Type (long/short)</Typography>
                </Grid>
                <Grid item xs={4.5}>
                  <Select
                    fullWidth
                    size='small'
                    name='htst1CipType'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.htst1CipType}
                    error={touched.htst1CipType && !!errors.htst1CipType}
                    helperText={touched.htst1CipType && errors.htst1CipType}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Short Wash'>Short Wash</MenuItem>
                    <MenuItem value='Long Wash'>Long Wash</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={4.5}>
                  <Select
                    fullWidth
                    size='small'
                    name='htst2CipType'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.htst2CipType}
                    error={touched.htst2CipType && !!errors.htst2CipType}
                    helperText={touched.htst2CipType && errors.htst2CipType}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Short Wash'>Short Wash</MenuItem>
                    <MenuItem value='Long Wash'>Long Wash</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>Last Flush</Typography>
                </Grid>
                <Grid item xs={4.5}>
                  <DateTimePicker
                    name='htst1LastFlush'
                    disabled={recordLock}
                    onChange={(value) =>
                      handleDateChange(
                        'htst1LastFlush',
                        value,
                        values,
                        setValues
                      )
                    }
                    value={values.htst1LastFlush}
                    error={touched.htst1LastFlush && !!errors.htst1LastFlush}
                    helperText={touched.htst1LastFlush && errors.htst1LastFlush}
                    renderInput={(params) => (
                      <TextField fullWidth size='small' {...params} />
                    )}
                  />
                </Grid>
                <Grid item xs={4.5}>
                  <DateTimePicker
                    name='htst2LastFlush'
                    disabled={recordLock}
                    onChange={(value) =>
                      handleDateChange(
                        'htst2LastFlush',
                        value,
                        values,
                        setValues
                      )
                    }
                    value={values.htst2LastFlush}
                    error={touched.htst2LastFlush && !!errors.htst2LastFlush}
                    helperText={touched.htst2LastFlush && errors.htst2LastFlush}
                    renderInput={(params) => (
                      <TextField fullWidth size='small' {...params} />
                    )}
                  />
                </Grid>
                <Grid item xs={3} sx={{ textAlign: 'right', pr: 1 }}>
                  <Typography>Last On Product</Typography>
                </Grid>

                <Grid
                  item
                  container
                  direction='row'
                  justifyContent='flex-start'
                  alignItems='center'
                  xs={2}
                >
                  {values.htst1LastOnProduct !== `Didn't Startup` ? (
                    <IconButton
                      disabled={recordLock}
                      onClick={() =>
                        handleChangeCheckbox(
                          'htst1LastOnProduct',
                          values,
                          setValues
                        )
                      }
                    >
                      <CheckBoxOutlineBlankIcon />
                    </IconButton>
                  ) : (
                    <IconButton
                      disabled={recordLock}
                      onClick={() =>
                        handleChangeCheckbox(
                          'htst1LastOnProduct',
                          values,
                          setValues
                        )
                      }
                    >
                      <CheckBoxIcon />
                    </IconButton>
                  )}
                  <Typography>Didn't Startup</Typography>
                </Grid>
                <Grid item xs={2.5}>
                  {values.htst1LastOnProduct !== `Didn't Startup` && (
                    <DateTimePicker
                      name='htst1LastOnProduct'
                      disabled={recordLock}
                      onChange={(value) =>
                        handleDateChange(
                          'htst1LastOnProduct',
                          value,
                          values,
                          setValues
                        )
                      }
                      value={values.htst1LastOnProduct}
                      error={
                        touched.htst1LastOnProduct &&
                        !!errors.htst1LastOnProduct
                      }
                      helperText={
                        touched.htst1LastOnProduct && errors.htst1LastOnProduct
                      }
                      renderInput={(params) => (
                        <TextField fullWidth size='small' {...params} />
                      )}
                    />
                  )}
                </Grid>
                <Grid
                  item
                  container
                  direction='row'
                  justifyContent='flex-start'
                  alignItems='center'
                  xs={2}
                >
                  {values.htst2LastOnProduct !== `Didn't Startup` ? (
                    <IconButton
                      disabled={recordLock}
                      onClick={() =>
                        handleChangeCheckbox(
                          'htst2LastOnProduct',
                          values,
                          setValues
                        )
                      }
                    >
                      <CheckBoxOutlineBlankIcon />
                    </IconButton>
                  ) : (
                    <IconButton
                      disabled={recordLock}
                      onClick={() =>
                        handleChangeCheckbox(
                          'htst2LastOnProduct',
                          values,
                          setValues
                        )
                      }
                    >
                      <CheckBoxIcon />
                    </IconButton>
                  )}
                  <Typography>Didn't Startup</Typography>
                </Grid>
                <Grid item xs={2.5}>
                  {values.htst2LastOnProduct !== `Didn't Startup` && (
                    <DateTimePicker
                      name='htst2LastOnProduct'
                      disabled={recordLock}
                      onChange={(value) =>
                        handleDateChange(
                          'htst2LastOnProduct',
                          value,
                          values,
                          setValues
                        )
                      }
                      value={values.htst2LastOnProduct}
                      error={
                        touched.htst2LastOnProduct &&
                        !!errors.htst2LastOnProduct
                      }
                      helperText={
                        touched.htst2LastOnProduct && errors.htst2LastOnProduct
                      }
                      renderInput={(params) => (
                        <TextField fullWidth size='small' {...params} />
                      )}
                    />
                  )}
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Raw Milk Silos
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Hrs
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Volume
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Status
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    SNF
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Fat
                  </Typography>
                </Grid>

                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 1
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo1Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo1Hours}
                    error={touched.silo1Hours && !!errors.silo1Hours}
                    helperText={touched.silo1Hours && errors.silo1Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo1Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo1Volume}
                    error={touched.silo1Volume && !!errors.silo1Volume}
                    helperText={touched.silo1Volume && errors.silo1Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo1Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo1Product}
                    error={touched.silo1Product && !!errors.silo1Product}
                    helperText={touched.silo1Product && errors.silo1Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo1Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo1Status}
                    error={touched.silo1Status && !!errors.silo1Status}
                    helperText={touched.silo1Status && errors.silo1Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo1Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo1Snf}
                    error={touched.silo1Snf && !!errors.silo1Snf}
                    helperText={touched.silo1Snf && errors.silo1Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo1Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo1Fat}
                    error={touched.silo1Fat && !!errors.silo1Fat}
                    helperText={touched.silo1Fat && errors.silo1Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 2
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo2Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo2Hours}
                    error={touched.silo2Hours && !!errors.silo2Hours}
                    helperText={touched.silo2Hours && errors.silo2Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo2Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo2Volume}
                    error={touched.silo2Volume && !!errors.silo2Volume}
                    helperText={touched.silo2Volume && errors.silo2Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo2Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo2Product}
                    error={touched.silo2Product && !!errors.silo2Product}
                    helperText={touched.silo2Product && errors.silo2Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo2Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo2Status}
                    error={touched.silo2Status && !!errors.silo2Status}
                    helperText={touched.silo2Status && errors.silo2Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo2Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo2Snf}
                    error={touched.silo2Snf && !!errors.silo2Snf}
                    helperText={touched.silo2Snf && errors.silo2Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo2Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo2Fat}
                    error={touched.silo2Fat && !!errors.silo2Fat}
                    helperText={touched.silo2Fat && errors.silo2Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 3
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo3Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo3Hours}
                    error={touched.silo3Hours && !!errors.silo3Hours}
                    helperText={touched.silo3Hours && errors.silo3Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo3Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo3Volume}
                    error={touched.silo3Volume && !!errors.silo3Volume}
                    helperText={touched.silo3Volume && errors.silo3Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo3Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo3Product}
                    error={touched.silo3Product && !!errors.silo3Product}
                    helperText={touched.silo3Product && errors.silo3Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo3Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo3Status}
                    error={touched.silo3Status && !!errors.silo3Status}
                    helperText={touched.silo3Status && errors.silo3Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo3Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo3Snf}
                    error={touched.silo3Snf && !!errors.silo3Snf}
                    helperText={touched.silo3Snf && errors.silo3Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo3Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo3Fat}
                    error={touched.silo3Fat && !!errors.silo3Fat}
                    helperText={touched.silo3Fat && errors.silo3Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 4
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo4Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo4Hours}
                    error={touched.silo4Hours && !!errors.silo4Hours}
                    helperText={touched.silo4Hours && errors.silo4Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo4Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo4Volume}
                    error={touched.silo4Volume && !!errors.silo4Volume}
                    helperText={touched.silo4Volume && errors.silo4Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo4Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo4Product}
                    error={touched.silo4Product && !!errors.silo4Product}
                    helperText={touched.silo4Product && errors.silo4Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo4Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo4Status}
                    error={touched.silo4Status && !!errors.silo4Status}
                    helperText={touched.silo4Status && errors.silo4Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo4Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo4Snf}
                    error={touched.silo4Snf && !!errors.silo4Snf}
                    helperText={touched.silo4Snf && errors.silo4Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo4Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo4Fat}
                    error={touched.silo4Fat && !!errors.silo4Fat}
                    helperText={touched.silo4Fat && errors.silo4Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 5
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo5Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo5Hours}
                    error={touched.silo5Hours && !!errors.silo5Hours}
                    helperText={touched.silo5Hours && errors.silo5Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo5Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo5Volume}
                    error={touched.silo5Volume && !!errors.silo5Volume}
                    helperText={touched.silo5Volume && errors.silo5Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo5Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo5Product}
                    error={touched.silo5Product && !!errors.silo5Product}
                    helperText={touched.silo5Product && errors.silo5Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo5Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo5Status}
                    error={touched.silo5Status && !!errors.silo5Status}
                    helperText={touched.silo5Status && errors.silo5Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo5Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo5Snf}
                    error={touched.silo5Snf && !!errors.silo5Snf}
                    helperText={touched.silo5Snf && errors.silo5Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo5Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo5Fat}
                    error={touched.silo5Fat && !!errors.silo5Fat}
                    helperText={touched.silo5Fat && errors.silo5Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Hybrid Raw Milk/Cream Silos
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Hrs
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Volume
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Status
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    SNF
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Fat
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 6
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo6Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo6Hours}
                    error={touched.silo6Hours && !!errors.silo6Hours}
                    helperText={touched.silo6Hours && errors.silo6Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo6Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo6Volume}
                    error={touched.silo6Volume && !!errors.silo6Volume}
                    helperText={touched.silo6Volume && errors.silo6Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo6Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo6Product}
                    error={touched.silo6Product && !!errors.silo6Product}
                    helperText={touched.silo6Product && errors.silo6Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo6Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo6Status}
                    error={touched.silo6Status && !!errors.silo6Status}
                    helperText={touched.silo6Status && errors.silo6Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo6Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo6Snf}
                    error={touched.silo6Snf && !!errors.silo6Snf}
                    helperText={touched.silo6Snf && errors.silo6Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo6Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo6Fat}
                    error={touched.silo6Fat && !!errors.silo6Fat}
                    helperText={touched.silo6Fat && errors.silo6Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 7
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo7Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo7Hours}
                    error={touched.silo7Hours && !!errors.silo7Hours}
                    helperText={touched.silo7Hours && errors.silo7Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo7Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo7Volume}
                    error={touched.silo7Volume && !!errors.silo7Volume}
                    helperText={touched.silo7Volume && errors.silo7Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo7Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo7Product}
                    error={touched.silo7Product && !!errors.silo7Product}
                    helperText={touched.silo7Product && errors.silo7Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo7Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo7Status}
                    error={touched.silo7Status && !!errors.silo7Status}
                    helperText={touched.silo7Status && errors.silo7Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo7Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo7Snf}
                    error={touched.silo7Snf && !!errors.silo7Snf}
                    helperText={touched.silo7Snf && errors.silo7Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo7Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo7Fat}
                    error={touched.silo7Fat && !!errors.silo7Fat}
                    helperText={touched.silo7Fat && errors.silo7Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Permeate Silos
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Hrs
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Volume
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Status
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    SNF
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Fat
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 9
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo9Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo9Hours}
                    error={touched.silo9Hours && !!errors.silo9Hours}
                    helperText={touched.silo9Hours && errors.silo9Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo9Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo9Volume}
                    error={touched.silo9Volume && !!errors.silo9Volume}
                    helperText={touched.silo9Volume && errors.silo9Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo9Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo9Product}
                    error={touched.silo9Product && !!errors.silo9Product}
                    helperText={touched.silo9Product && errors.silo9Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo9Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo9Status}
                    error={touched.silo9Status && !!errors.silo9Status}
                    helperText={touched.silo9Status && errors.silo9Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo9Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo9Snf}
                    error={touched.silo9Snf && !!errors.silo9Snf}
                    helperText={touched.silo9Snf && errors.silo9Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo9Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo9Fat}
                    error={touched.silo9Fat && !!errors.silo9Fat}
                    helperText={touched.silo9Fat && errors.silo9Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 10
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo10Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo10Hours}
                    error={touched.silo10Hours && !!errors.silo10Hours}
                    helperText={touched.silo10Hours && errors.silo10Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo10Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo10Volume}
                    error={touched.silo10Volume && !!errors.silo10Volume}
                    helperText={touched.silo10Volume && errors.silo10Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo10Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo10Product}
                    error={touched.silo10Product && !!errors.silo10Product}
                    helperText={touched.silo10Product && errors.silo10Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo10Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo10Status}
                    error={touched.silo10Status && !!errors.silo10Status}
                    helperText={touched.silo10Status && errors.silo10Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo10Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo10Snf}
                    error={touched.silo10Snf && !!errors.silo10Snf}
                    helperText={touched.silo10Snf && errors.silo10Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo10Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo10Fat}
                    error={touched.silo10Fat && !!errors.silo10Fat}
                    helperText={touched.silo10Fat && errors.silo10Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Pasteurized Cream Silos
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Hrs
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Volume
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Status
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    SNF
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Fat
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 11
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo11Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo11Hours}
                    error={touched.silo11Hours && !!errors.silo11Hours}
                    helperText={touched.silo11Hours && errors.silo11Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo11Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo11Volume}
                    error={touched.silo11Volume && !!errors.silo11Volume}
                    helperText={touched.silo11Volume && errors.silo11Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo11Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo11Product}
                    error={touched.silo11Product && !!errors.silo11Product}
                    helperText={touched.silo11Product && errors.silo11Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo11Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo11Status}
                    error={touched.silo11Status && !!errors.silo11Status}
                    helperText={touched.silo11Status && errors.silo11Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo11Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo11Snf}
                    error={touched.silo11Snf && !!errors.silo11Snf}
                    helperText={touched.silo11Snf && errors.silo11Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo11Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo11Fat}
                    error={touched.silo11Fat && !!errors.silo11Fat}
                    helperText={touched.silo11Fat && errors.silo11Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 12
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo12Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo12Hours}
                    error={touched.silo12Hours && !!errors.silo12Hours}
                    helperText={touched.silo12Hours && errors.silo12Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo12Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo12Volume}
                    error={touched.silo12Volume && !!errors.silo12Volume}
                    helperText={touched.silo12Volume && errors.silo12Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo12Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo12Product}
                    error={touched.silo12Product && !!errors.silo12Product}
                    helperText={touched.silo12Product && errors.silo12Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo12Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo12Status}
                    error={touched.silo12Status && !!errors.silo12Status}
                    helperText={touched.silo12Status && errors.silo12Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo12Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo12Snf}
                    error={touched.silo12Snf && !!errors.silo12Snf}
                    helperText={touched.silo12Snf && errors.silo12Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo12Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo12Fat}
                    error={touched.silo12Fat && !!errors.silo12Fat}
                    helperText={touched.silo12Fat && errors.silo12Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 15
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo15Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo15Hours}
                    error={touched.silo15Hours && !!errors.silo15Hours}
                    helperText={touched.silo15Hours && errors.silo15Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo15Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo15Volume}
                    error={touched.silo15Volume && !!errors.silo15Volume}
                    helperText={touched.silo15Volume && errors.silo15Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo15Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo15Product}
                    error={touched.silo15Product && !!errors.silo15Product}
                    helperText={touched.silo15Product && errors.silo15Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo15Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo15Status}
                    error={touched.silo15Status && !!errors.silo15Status}
                    helperText={touched.silo15Status && errors.silo15Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo15Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo15Snf}
                    error={touched.silo15Snf && !!errors.silo15Snf}
                    helperText={touched.silo15Snf && errors.silo15Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo15Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo15Fat}
                    error={touched.silo15Fat && !!errors.silo15Fat}
                    helperText={touched.silo15Fat && errors.silo15Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 24
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo24Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo24Hours}
                    error={touched.silo24Hours && !!errors.silo24Hours}
                    helperText={touched.silo24Hours && errors.silo24Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo24Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo24Volume}
                    error={touched.silo24Volume && !!errors.silo24Volume}
                    helperText={touched.silo24Volume && errors.silo24Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo24Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo24Product}
                    error={touched.silo24Product && !!errors.silo24Product}
                    helperText={touched.silo24Product && errors.silo24Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo24Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo24Status}
                    error={touched.silo24Status && !!errors.silo24Status}
                    helperText={touched.silo24Status && errors.silo24Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo24Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo24Snf}
                    error={touched.silo24Snf && !!errors.silo24Snf}
                    helperText={touched.silo24Snf && errors.silo24Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo24Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo24Fat}
                    error={touched.silo24Fat && !!errors.silo24Fat}
                    helperText={touched.silo24Fat && errors.silo24Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Skim Milk Silos
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Hrs
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Volume
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Status
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    SNF
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Fat
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 14
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo14Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo14Hours}
                    error={touched.silo14Hours && !!errors.silo14Hours}
                    helperText={touched.silo14Hours && errors.silo14Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo14Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo14Volume}
                    error={touched.silo14Volume && !!errors.silo14Volume}
                    helperText={touched.silo14Volume && errors.silo14Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo14Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo14Product}
                    error={touched.silo14Product && !!errors.silo14Product}
                    helperText={touched.silo14Product && errors.silo14Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo14Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo14Status}
                    error={touched.silo14Status && !!errors.silo14Status}
                    helperText={touched.silo14Status && errors.silo14Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo14Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo14Snf}
                    error={touched.silo14Snf && !!errors.silo14Snf}
                    helperText={touched.silo14Snf && errors.silo14Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo14Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo14Fat}
                    error={touched.silo14Fat && !!errors.silo14Fat}
                    helperText={touched.silo14Fat && errors.silo14Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 16
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo16Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo16Hours}
                    error={touched.silo16Hours && !!errors.silo16Hours}
                    helperText={touched.silo16Hours && errors.silo16Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo16Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo16Volume}
                    error={touched.silo16Volume && !!errors.silo16Volume}
                    helperText={touched.silo16Volume && errors.silo16Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo16Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo16Product}
                    error={touched.silo16Product && !!errors.silo16Product}
                    helperText={touched.silo16Product && errors.silo16Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo16Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo16Status}
                    error={touched.silo16Status && !!errors.silo16Status}
                    helperText={touched.silo16Status && errors.silo16Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo16Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo16Snf}
                    error={touched.silo16Snf && !!errors.silo16Snf}
                    helperText={touched.silo16Snf && errors.silo16Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo16Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo16Fat}
                    error={touched.silo16Fat && !!errors.silo16Fat}
                    helperText={touched.silo16Fat && errors.silo16Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 26
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo26Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo26Hours}
                    error={touched.silo26Hours && !!errors.silo26Hours}
                    helperText={touched.silo26Hours && errors.silo26Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo26Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo26Volume}
                    error={touched.silo26Volume && !!errors.silo26Volume}
                    helperText={touched.silo26Volume && errors.silo26Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo26Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo26Product}
                    error={touched.silo26Product && !!errors.silo26Product}
                    helperText={touched.silo26Product && errors.silo26Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo26Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo26Status}
                    error={touched.silo26Status && !!errors.silo26Status}
                    helperText={touched.silo26Status && errors.silo26Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo26Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo26Snf}
                    error={touched.silo26Snf && !!errors.silo26Snf}
                    helperText={touched.silo26Snf && errors.silo26Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo26Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo26Fat}
                    error={touched.silo26Fat && !!errors.silo26Fat}
                    helperText={touched.silo26Fat && errors.silo26Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Utility Silos
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Hrs
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Volume
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Status
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    SNF
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Fat
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 13
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo13Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo13Hours}
                    error={touched.silo13Hours && !!errors.silo13Hours}
                    helperText={touched.silo13Hours && errors.silo13Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo13Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo13Volume}
                    error={touched.silo13Volume && !!errors.silo13Volume}
                    helperText={touched.silo13Volume && errors.silo13Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo13Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo13Product}
                    error={touched.silo13Product && !!errors.silo13Product}
                    helperText={touched.silo13Product && errors.silo13Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo13Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo13Status}
                    error={touched.silo13Status && !!errors.silo13Status}
                    helperText={touched.silo13Status && errors.silo13Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo13Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo13Snf}
                    error={touched.silo13Snf && !!errors.silo13Snf}
                    helperText={touched.silo13Snf && errors.silo13Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo13Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo13Fat}
                    error={touched.silo13Fat && !!errors.silo13Fat}
                    helperText={touched.silo13Fat && errors.silo13Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 25
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo25Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo25Hours}
                    error={touched.silo25Hours && !!errors.silo25Hours}
                    helperText={touched.silo25Hours && errors.silo25Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo25Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo25Volume}
                    error={touched.silo25Volume && !!errors.silo25Volume}
                    helperText={touched.silo25Volume && errors.silo25Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo25Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo25Product}
                    error={touched.silo25Product && !!errors.silo25Product}
                    helperText={touched.silo25Product && errors.silo25Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo25Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo25Status}
                    error={touched.silo25Status && !!errors.silo25Status}
                    helperText={touched.silo25Status && errors.silo25Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo25Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo25Snf}
                    error={touched.silo25Snf && !!errors.silo25Snf}
                    helperText={touched.silo25Snf && errors.silo25Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo25Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo25Fat}
                    error={touched.silo25Fat && !!errors.silo25Fat}
                    helperText={touched.silo25Fat && errors.silo25Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Buttermilk Silos
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Hrs
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Volume
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Status
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    SNF
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Fat
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 22
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo22Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo22Hours}
                    error={touched.silo22Hours && !!errors.silo22Hours}
                    helperText={touched.silo22Hours && errors.silo22Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo22Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo22Volume}
                    error={touched.silo22Volume && !!errors.silo22Volume}
                    helperText={touched.silo22Volume && errors.silo22Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo22Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo22Product}
                    error={touched.silo22Product && !!errors.silo22Product}
                    helperText={touched.silo22Product && errors.silo22Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo22Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo22Status}
                    error={touched.silo22Status && !!errors.silo22Status}
                    helperText={touched.silo22Status && errors.silo22Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo22Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo22Snf}
                    error={touched.silo22Snf && !!errors.silo22Snf}
                    helperText={touched.silo22Snf && errors.silo22Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo22Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo22Fat}
                    error={touched.silo22Fat && !!errors.silo22Fat}
                    helperText={touched.silo22Fat && errors.silo22Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 23
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo23Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo23Hours}
                    error={touched.silo23Hours && !!errors.silo23Hours}
                    helperText={touched.silo23Hours && errors.silo23Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo23Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo23Volume}
                    error={touched.silo23Volume && !!errors.silo23Volume}
                    helperText={touched.silo23Volume && errors.silo23Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo23Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo23Product}
                    error={touched.silo23Product && !!errors.silo23Product}
                    helperText={touched.silo23Product && errors.silo23Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo23Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo23Status}
                    error={touched.silo23Status && !!errors.silo23Status}
                    helperText={touched.silo23Status && errors.silo23Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo23Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo23Snf}
                    error={touched.silo23Snf && !!errors.silo23Snf}
                    helperText={touched.silo23Snf && errors.silo23Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo23Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo23Fat}
                    error={touched.silo23Fat && !!errors.silo23Fat}
                    helperText={touched.silo23Fat && errors.silo23Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Water Silos
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Hrs
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Volume
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Status
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    SNF
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Fat
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 18
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo18Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo18Hours}
                    error={touched.silo18Hours && !!errors.silo18Hours}
                    helperText={touched.silo18Hours && errors.silo18Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo18Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo18Volume}
                    error={touched.silo18Volume && !!errors.silo18Volume}
                    helperText={touched.silo18Volume && errors.silo18Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo18Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo18Product}
                    error={touched.silo18Product && !!errors.silo18Product}
                    helperText={touched.silo18Product && errors.silo18Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo18Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo18Status}
                    error={touched.silo18Status && !!errors.silo18Status}
                    helperText={touched.silo18Status && errors.silo18Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo18Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo18Snf}
                    error={touched.silo18Snf && !!errors.silo18Snf}
                    helperText={touched.silo18Snf && errors.silo18Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo18Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo18Fat}
                    error={touched.silo18Fat && !!errors.silo18Fat}
                    helperText={touched.silo18Fat && errors.silo18Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 19
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo19Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo19Hours}
                    error={touched.silo19Hours && !!errors.silo19Hours}
                    helperText={touched.silo19Hours && errors.silo19Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo19Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo19Volume}
                    error={touched.silo19Volume && !!errors.silo19Volume}
                    helperText={touched.silo19Volume && errors.silo19Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo19Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo19Product}
                    error={touched.silo19Product && !!errors.silo19Product}
                    helperText={touched.silo19Product && errors.silo19Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo19Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo19Status}
                    error={touched.silo19Status && !!errors.silo19Status}
                    helperText={touched.silo19Status && errors.silo19Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo19Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo19Snf}
                    error={touched.silo19Snf && !!errors.silo19Snf}
                    helperText={touched.silo19Snf && errors.silo19Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo19Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo19Fat}
                    error={touched.silo19Fat && !!errors.silo19Fat}
                    helperText={touched.silo19Fat && errors.silo19Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 20
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo20Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo20Hours}
                    error={touched.silo20Hours && !!errors.silo20Hours}
                    helperText={touched.silo20Hours && errors.silo20Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo20Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo20Volume}
                    error={touched.silo20Volume && !!errors.silo20Volume}
                    helperText={touched.silo20Volume && errors.silo20Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo20Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo20Product}
                    error={touched.silo20Product && !!errors.silo20Product}
                    helperText={touched.silo20Product && errors.silo20Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo20Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo20Status}
                    error={touched.silo20Status && !!errors.silo20Status}
                    helperText={touched.silo20Status && errors.silo20Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo20Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo20Snf}
                    error={touched.silo20Snf && !!errors.silo20Snf}
                    helperText={touched.silo20Snf && errors.silo20Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo20Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo20Fat}
                    error={touched.silo20Fat && !!errors.silo20Fat}
                    helperText={touched.silo20Fat && errors.silo20Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 21
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo21Hours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo21Hours}
                    error={touched.silo21Hours && !!errors.silo21Hours}
                    helperText={touched.silo21Hours && errors.silo21Hours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo21Volume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo21Volume}
                    error={touched.silo21Volume && !!errors.silo21Volume}
                    helperText={touched.silo21Volume && errors.silo21Volume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo21Product'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.silo21Product}
                    error={touched.silo21Product && !!errors.silo21Product}
                    helperText={touched.silo21Product && errors.silo21Product}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='silo21Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo21Status}
                    error={touched.silo21Status && !!errors.silo21Status}
                    helperText={touched.silo21Status && errors.silo21Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo21Snf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo21Snf}
                    error={touched.silo21Snf && !!errors.silo21Snf}
                    helperText={touched.silo21Snf && errors.silo21Snf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='silo21Fat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.silo21Fat}
                    error={touched.silo21Fat && !!errors.silo21Fat}
                    helperText={touched.silo21Fat && errors.silo21Fat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Total Water
                  </Typography>
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='totalWater'
                    disabled={true}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.totalWater}
                    error={touched.totalWater && !!errors.totalWater}
                    helperText={touched.totalWater && errors.totalWater}
                  />
                </Grid>
                <Grid item xs={6}></Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    White Rinse Tanks
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Hrs
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Volume
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Status
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    SNF
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Fat
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    HTST
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='htstTnkHours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.htstTnkHours}
                    error={touched.htstTnkHours && !!errors.htstTnkHours}
                    helperText={touched.htstTnkHours && errors.htstTnkHours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='htstTnkVolume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.htstTnkVolume}
                    error={touched.htstTnkVolume && !!errors.htstTnkVolume}
                    helperText={touched.htstTnkVolume && errors.htstTnkVolume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='htstTnkProduct'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.htstTnkProduct}
                    error={touched.htstTnkProduct && !!errors.htstTnkProduct}
                    helperText={touched.htstTnkProduct && errors.htstTnkProduct}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='htstTnkStatus'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.htstTnkStatus}
                    error={touched.htstTnkStatus && !!errors.htstTnkStatus}
                    helperText={touched.htstTnkStatus && errors.htstTnkStatus}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='htstTnkSnf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.htstTnkSnf}
                    error={touched.htstTnkSnf && !!errors.htstTnkSnf}
                    helperText={touched.htstTnkSnf && errors.htstTnkSnf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='htstTnkFat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.htstTnkFat}
                    error={touched.htstTnkFat && !!errors.htstTnkFat}
                    helperText={touched.htstTnkFat && errors.htstTnkFat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Evap
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='evapTnkHours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.evapTnkHours}
                    error={touched.evapTnkHours && !!errors.evapTnkHours}
                    helperText={touched.evapTnkHours && errors.evapTnkHours}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='evapTnkVolume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.evapTnkVolume}
                    error={touched.evapTnkVolume && !!errors.evapTnkVolume}
                    helperText={touched.evapTnkVolume && errors.evapTnkVolume}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='evapTnkProduct'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.evapTnkProduct}
                    error={touched.evapTnkProduct && !!errors.evapTnkProduct}
                    helperText={touched.evapTnkProduct && errors.evapTnkProduct}
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='evapTnkStatus'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.evapTnkStatus}
                    error={touched.evapTnkStatus && !!errors.evapTnkStatus}
                    helperText={touched.evapTnkStatus && errors.evapTnkStatus}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='evapTnkSnf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.evapTnkSnf}
                    error={touched.evapTnkSnf && !!errors.evapTnkSnf}
                    helperText={touched.evapTnkSnf && errors.evapTnkSnf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='evapTnkFat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.evapTnkFat}
                    error={touched.evapTnkFat && !!errors.evapTnkFat}
                    helperText={touched.evapTnkFat && errors.evapTnkFat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Recovery
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='recoveryTnkHours'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.recoveryTnkHours}
                    error={
                      touched.recoveryTnkHours && !!errors.recoveryTnkHours
                    }
                    helperText={
                      touched.recoveryTnkHours && errors.recoveryTnkHours
                    }
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    size='small'
                    name='recoveryTnkVolume'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.recoveryTnkVolume}
                    error={
                      touched.recoveryTnkVolume && !!errors.recoveryTnkVolume
                    }
                    helperText={
                      touched.recoveryTnkVolume && errors.recoveryTnkVolume
                    }
                  />
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='recoveryTnkProduct'
                    disabled={recordLock}
                    onChange={(e) => calSiloTotals(e, values, setValues)}
                    value={values.recoveryTnkProduct}
                    error={
                      touched.recoveryTnkProduct && !!errors.recoveryTnkProduct
                    }
                    helperText={
                      touched.recoveryTnkProduct && errors.recoveryTnkProduct
                    }
                  >
                    <MenuItem value='Recon'>Recon</MenuItem>
                    <MenuItem value='Raw Milk'>Raw Milk</MenuItem>
                    <MenuItem value='Skim Milk'>Skim Milk</MenuItem>
                    <MenuItem value='Permeate'>Permeate</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                    <MenuItem value='Pasteurized Cream'>
                      Pasteurized Cream
                    </MenuItem>
                    <MenuItem value='Raw Cream'>Raw Cream</MenuItem>
                    <MenuItem value='Condensed'>Condensed</MenuItem>
                    <MenuItem value='Water'>Water</MenuItem>
                    <MenuItem value='Chemical'>Chemical</MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='Other'>Other, specify in message</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    fullWidth
                    size='small'
                    name='recoveryTnkStatus'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.recoveryTnkStatus}
                    error={
                      touched.recoveryTnkStatus && !!errors.recoveryTnkStatus
                    }
                    helperText={
                      touched.recoveryTnkStatus && errors.recoveryTnkStatus
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='recoveryTnkSnf'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.recoveryTnkSnf}
                    error={touched.recoveryTnkSnf && !!errors.recoveryTnkSnf}
                    helperText={touched.recoveryTnkSnf && errors.recoveryTnkSnf}
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    size='small'
                    name='recoveryTnkFat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.recoveryTnkFat}
                    error={touched.recoveryTnkFat && !!errors.recoveryTnkFat}
                    helperText={touched.recoveryTnkFat && errors.recoveryTnkFat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Milk RO
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Baseline Pressure
                  </Typography>
                </Grid>
                <Grid item xs={1.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='milkRoBaselinePressure'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.milkRoBaselinePressure}
                    error={
                      touched.milkRoBaselinePressure &&
                      !!errors.milkRoBaselinePressure
                    }
                    helperText={
                      touched.milkRoBaselinePressure &&
                      errors.milkRoBaselinePressure
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Loop 1
                  </Typography>
                </Grid>
                <Grid item xs={1.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='milkRoLoop1'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.milkRoLoop1}
                    error={touched.milkRoLoop1 && !!errors.milkRoLoop1}
                    helperText={touched.milkRoLoop1 && errors.milkRoLoop1}
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Loop 2
                  </Typography>
                </Grid>
                <Grid item xs={1.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='milkRoLoop2'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.milkRoLoop2}
                    error={touched.milkRoLoop2 && !!errors.milkRoLoop2}
                    helperText={touched.milkRoLoop2 && errors.milkRoLoop2}
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Feed Flow
                  </Typography>
                </Grid>
                <Grid item xs={1.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='milkRoFeedFlow'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.milkRoFeedFlow}
                    error={touched.milkRoFeedFlow && !!errors.milkRoFeedFlow}
                    helperText={touched.milkRoFeedFlow && errors.milkRoFeedFlow}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Solids
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='milkRoSolids'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.milkRoSolids}
                    error={touched.milkRoSolids && !!errors.milkRoSolids}
                    helperText={touched.milkRoSolids && errors.milkRoSolids}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Polisher
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Baseline Pressure
                  </Typography>
                </Grid>
                <Grid item xs={1.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='polisherBaselinePressure'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.polisherBaselinePressure}
                    error={
                      touched.polisherBaselinePressure &&
                      !!errors.polisherBaselinePressure
                    }
                    helperText={
                      touched.polisherBaselinePressure &&
                      errors.polisherBaselinePressure
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Loop 1
                  </Typography>
                </Grid>
                <Grid item xs={1.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='polisherLoop1'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.polisherLoop1}
                    error={touched.polisherLoop1 && !!errors.polisherLoop1}
                    helperText={touched.polisherLoop1 && errors.polisherLoop1}
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Loop 2
                  </Typography>
                </Grid>
                <Grid item xs={1.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='polisherLoop2'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.polisherLoop2}
                    error={touched.polisherLoop2 && !!errors.polisherLoop2}
                    helperText={touched.polisherLoop2 && errors.polisherLoop2}
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Feed Flow
                  </Typography>
                </Grid>
                <Grid item xs={1.5}>
                  <TextField
                    fullWidth
                    size='small'
                    name='polisherFeedFlow'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.polisherFeedFlow}
                    error={
                      touched.polisherFeedFlow && !!errors.polisherFeedFlow
                    }
                    helperText={
                      touched.polisherFeedFlow && errors.polisherFeedFlow
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Permeate RO
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Baseline Pressure
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='permeateRoBaselinePressure'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.permeateRoBaselinePressure}
                    error={
                      touched.permeateRoBaselinePressure &&
                      !!errors.permeateRoBaselinePressure
                    }
                    helperText={
                      touched.permeateRoBaselinePressure &&
                      errors.permeateRoBaselinePressure
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>Bx</Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='permeateRoBx'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.permeateRoBx}
                    error={touched.permeateRoBx && !!errors.permeateRoBx}
                    helperText={touched.permeateRoBx && errors.permeateRoBx}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    UF
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Baseline Pressure
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='ufBaselinePressure'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.ufBaselinePressure}
                    error={
                      touched.ufBaselinePressure && !!errors.ufBaselinePressure
                    }
                    helperText={
                      touched.ufBaselinePressure && errors.ufBaselinePressure
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>Bx</Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='ufBx'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.ufBx}
                    error={touched.ufBx && !!errors.ufBx}
                    helperText={touched.ufBx && errors.ufBx}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Feed Flow
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='ufFeedFlow'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.ufFeedFlow}
                    error={touched.ufFeedFlow && !!errors.ufFeedFlow}
                    helperText={touched.ufFeedFlow && errors.ufFeedFlow}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Protein
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='ufProtein'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.ufProtein}
                    error={touched.ufProtein && !!errors.ufProtein}
                    helperText={touched.ufProtein && errors.ufProtein}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Current Product
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='ufCurrentProduct'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.ufCurrentProduct}
                    error={
                      touched.ufCurrentProduct && !!errors.ufCurrentProduct
                    }
                    helperText={
                      touched.ufCurrentProduct && errors.ufCurrentProduct
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Last Flush
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <DateTimePicker
                    name='ufLastFlush'
                    disabled={recordLock}
                    onChange={(value) =>
                      handleDateChange('ufLastFlush', value, values, setValues)
                    }
                    value={values.ufLastFlush}
                    error={touched.ufLastFlush && !!errors.ufLastFlush}
                    helperText={touched.ufLastFlush && errors.ufLastFlush}
                    renderInput={(params) => (
                      <TextField fullWidth size='small' {...params} />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Last On Product
                  </Typography>
                </Grid>
                <Grid
                  item
                  container
                  direction='row'
                  justifyContent='flex-start'
                  alignItems='center'
                  xs={2}
                >
                  {values.ufLastOnProduct !== `Didn't Startup` ? (
                    <IconButton
                      disabled={recordLock}
                      onClick={() =>
                        handleChangeCheckbox(
                          'ufLastOnProduct',
                          values,
                          setValues
                        )
                      }
                    >
                      <CheckBoxOutlineBlankIcon />
                    </IconButton>
                  ) : (
                    <IconButton
                      disabled={recordLock}
                      onClick={() =>
                        handleChangeCheckbox(
                          'ufLastOnProduct',
                          values,
                          setValues
                        )
                      }
                    >
                      <CheckBoxIcon />
                    </IconButton>
                  )}
                  <Typography>Didn't Startup</Typography>
                </Grid>
                <Grid item xs={7}>
                  {values.ufLastOnProduct !== `Didn't Startup` && (
                    <DateTimePicker
                      name='ufLastOnProduct'
                      disabled={recordLock}
                      onChange={(value) =>
                        handleDateChange(
                          'ufLastOnProduct',
                          value,
                          values,
                          setValues
                        )
                      }
                      value={values.ufLastOnProduct}
                      error={
                        touched.ufLastOnProduct && !!errors.ufLastOnProduct
                      }
                      helperText={
                        touched.ufLastOnProduct && errors.ufLastOnProduct
                      }
                      renderInput={(params) => (
                        <TextField fullWidth size='small' {...params} />
                      )}
                    />
                  )}
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    NF
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Baseline Pressure
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='nfBaselinePressure'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.nfBaselinePressure}
                    error={
                      touched.nfBaselinePressure && !!errors.nfBaselinePressure
                    }
                    helperText={
                      touched.nfBaselinePressure && errors.nfBaselinePressure
                    }
                  />
                </Grid>

                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>Bx</Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='nfBx'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.nfBx}
                    error={touched.nfBx && !!errors.nfBx}
                    helperText={touched.nfBx && errors.nfBx}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Feed Flow
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='nfFeedFlow'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.nfFeedFlow}
                    error={touched.nfFeedFlow && !!errors.nfFeedFlow}
                    helperText={touched.nfFeedFlow && errors.nfFeedFlow}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Slip Stream Flow
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='nfSlipStreamFlow'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.nfSlipStreamFlow}
                    error={
                      touched.nfSlipStreamFlow && !!errors.nfSlipStreamFlow
                    }
                    helperText={
                      touched.nfSlipStreamFlow && errors.nfSlipStreamFlow
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    BUTTER
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Currently Pulling Silo
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterCurrentlyPullingSilo'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterCurrentlyPullingSilo}
                    error={
                      touched.butterCurrentlyPullingSilo &&
                      !!errors.butterCurrentlyPullingSilo
                    }
                    helperText={
                      touched.butterCurrentlyPullingSilo &&
                      errors.butterCurrentlyPullingSilo
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Churn 1
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Last Flush
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <DateTimePicker
                    name='butterLastFlushChurn1'
                    disabled={recordLock}
                    onChange={(value) =>
                      handleDateChange(
                        'butterLastFlushChurn1',
                        value,
                        values,
                        setValues
                      )
                    }
                    value={values.butterLastFlushChurn1}
                    error={
                      touched.butterLastFlushChurn1 &&
                      !!errors.butterLastFlushChurn1
                    }
                    helperText={
                      touched.butterLastFlushChurn1 &&
                      errors.butterLastFlushChurn1
                    }
                    renderInput={(params) => (
                      <TextField fullWidth size='small' {...params} />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Last On Product
                  </Typography>
                </Grid>
                <Grid
                  item
                  container
                  direction='row'
                  justifyContent='flex-start'
                  alignItems='center'
                  xs={2}
                >
                  {values.butterLastOnProductChurn1 !== `Didn't Startup` ? (
                    <IconButton
                      disabled={recordLock}
                      onClick={() =>
                        handleChangeCheckbox(
                          'butterLastOnProductChurn1',
                          values,
                          setValues
                        )
                      }
                    >
                      <CheckBoxOutlineBlankIcon />
                    </IconButton>
                  ) : (
                    <IconButton
                      disabled={recordLock}
                      onClick={() =>
                        handleChangeCheckbox(
                          'butterLastOnProductChurn1',
                          values,
                          setValues
                        )
                      }
                    >
                      <CheckBoxIcon />
                    </IconButton>
                  )}
                  <Typography>Didn't Startup</Typography>
                </Grid>
                <Grid item xs={7}>
                  {values.butterLastOnProductChurn1 !== `Didn't Startup` && (
                    <DateTimePicker
                      name='butterLastOnProductChurn1'
                      disabled={recordLock}
                      onChange={(value) =>
                        handleDateChange(
                          'butterLastOnProductChurn1',
                          value,
                          values,
                          setValues
                        )
                      }
                      value={values.butterLastOnProductChurn1}
                      error={
                        touched.butterLastOnProductChurn1 &&
                        !!errors.butterLastOnProductChurn1
                      }
                      helperText={
                        touched.butterLastOnProductChurn1 &&
                        errors.butterLastOnProductChurn1
                      }
                      renderInput={(params) => (
                        <TextField fullWidth size='small' {...params} />
                      )}
                    />
                  )}
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Cream to Churn RPM
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterCreamToChurnRpmChurn1'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterCreamToChurnRpmChurn1}
                    error={
                      touched.butterCreamToChurnRpmChurn1 &&
                      !!errors.butterCreamToChurnRpmChurn1
                    }
                    helperText={
                      touched.butterCreamToChurnRpmChurn1 &&
                      errors.butterCreamToChurnRpmChurn1
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Fat % During Shift
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterAvgFatChurn1'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterAvgFatChurn1}
                    error={
                      touched.butterAvgFatChurn1 && !!errors.butterAvgFatChurn1
                    }
                    helperText={
                      touched.butterAvgFatChurn1 && errors.butterAvgFatChurn1
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Salt % During Shift
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterAvgSaltChurn1'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterAvgSaltChurn1}
                    error={
                      touched.butterAvgSaltChurn1 &&
                      !!errors.butterAvgSaltChurn1
                    }
                    helperText={
                      touched.butterAvgSaltChurn1 && errors.butterAvgSaltChurn1
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Moisture % During Shift
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterAvgMoistChurn1'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterAvgMoistChurn1}
                    error={
                      touched.butterAvgMoistChurn1 &&
                      !!errors.butterAvgMoistChurn1
                    }
                    helperText={
                      touched.butterAvgMoistChurn1 &&
                      errors.butterAvgMoistChurn1
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg pH % During Shift
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterAvgPhChurn1'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterAvgPhChurn1}
                    error={
                      touched.butterAvgPhChurn1 && !!errors.butterAvgPhChurn1
                    }
                    helperText={
                      touched.butterAvgPhChurn1 && errors.butterAvgPhChurn1
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    Churn 2
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Last Flush
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <DateTimePicker
                    name='butterLastFlushChurn2'
                    disabled={recordLock}
                    onChange={(value) =>
                      handleDateChange(
                        'butterLastFlushChurn2',
                        value,
                        values,
                        setValues
                      )
                    }
                    value={values.butterLastFlushChurn2}
                    error={
                      touched.butterLastFlushChurn2 &&
                      !!errors.butterLastFlushChurn2
                    }
                    helperText={
                      touched.butterLastFlushChurn2 &&
                      errors.butterLastFlushChurn2
                    }
                    renderInput={(params) => (
                      <TextField fullWidth size='small' {...params} />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Last On Product
                  </Typography>
                </Grid>
                <Grid
                  item
                  container
                  direction='row'
                  justifyContent='flex-start'
                  alignItems='center'
                  xs={2}
                >
                  {values.butterLastOnProductChurn2 !== `Didn't Startup` ? (
                    <IconButton
                      disabled={recordLock}
                      onClick={() =>
                        handleChangeCheckbox(
                          'butterLastOnProductChurn2',
                          values,
                          setValues
                        )
                      }
                    >
                      <CheckBoxOutlineBlankIcon />
                    </IconButton>
                  ) : (
                    <IconButton
                      disabled={recordLock}
                      onClick={() =>
                        handleChangeCheckbox(
                          'butterLastOnProductChurn2',
                          values,
                          setValues
                        )
                      }
                    >
                      <CheckBoxIcon />
                    </IconButton>
                  )}
                  <Typography>Didn't Startup</Typography>
                </Grid>
                <Grid item xs={7}>
                  {values.butterLastOnProductChurn2 !== `Didn't Startup` && (
                    <DateTimePicker
                      name='butterLastOnProductChurn2'
                      disabled={recordLock}
                      onChange={(value) =>
                        handleDateChange(
                          'butterLastOnProductChurn2',
                          value,
                          values,
                          setValues
                        )
                      }
                      value={values.butterLastOnProductChurn2}
                      error={
                        touched.butterLastOnProductChurn2 &&
                        !!errors.butterLastOnProductChurn2
                      }
                      helperText={
                        touched.butterLastOnProductChurn2 &&
                        errors.butterLastOnProductChurn2
                      }
                      renderInput={(params) => (
                        <TextField fullWidth size='small' {...params} />
                      )}
                    />
                  )}
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Cream to Churn RPM
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterCreamToChurnRpmChurn2'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterCreamToChurnRpmChurn2}
                    error={
                      touched.butterCreamToChurnRpmChurn2 &&
                      !!errors.butterCreamToChurnRpmChurn2
                    }
                    helperText={
                      touched.butterCreamToChurnRpmChurn2 &&
                      errors.butterCreamToChurnRpmChurn2
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Fat % During Shift
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterAvgFatChurn2'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterAvgFatChurn2}
                    error={
                      touched.butterAvgFatChurn2 && !!errors.butterAvgFatChurn2
                    }
                    helperText={
                      touched.butterAvgFatChurn2 && errors.butterAvgFatChurn2
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Salt % During Shift
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterAvgSaltChurn2'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterAvgSaltChurn2}
                    error={
                      touched.butterAvgSaltChurn2 &&
                      !!errors.butterAvgSaltChurn2
                    }
                    helperText={
                      touched.butterAvgSaltChurn2 && errors.butterAvgSaltChurn2
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Moisture % During Shift
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterAvgMoistChurn2'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterAvgMoistChurn2}
                    error={
                      touched.butterAvgMoistChurn2 &&
                      !!errors.butterAvgMoistChurn2
                    }
                    helperText={
                      touched.butterAvgMoistChurn2 &&
                      errors.butterAvgMoistChurn2
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg pH % During Shift
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterAvgPhChurn2'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterAvgPhChurn2}
                    error={
                      touched.butterAvgPhChurn2 && !!errors.butterAvgPhChurn2
                    }
                    helperText={
                      touched.butterAvgPhChurn2 && errors.butterAvgPhChurn2
                    }
                  />
                </Grid>
                <Grid item xs={12} sx={{ pt: 3 }}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Buttermilk to Silo
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterButtermilkToSilo'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterButtermilkToSilo}
                    error={
                      touched.butterButtermilkToSilo &&
                      !!errors.butterButtermilkToSilo
                    }
                    helperText={
                      touched.butterButtermilkToSilo &&
                      errors.butterButtermilkToSilo
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Pallets Produced
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterPalletsProduced1'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) =>
                      calTotalButterPallets(e, values, setValues)
                    }
                    value={values.butterPalletsProduced1}
                    error={
                      touched.butterPalletsProduced1 &&
                      !!errors.butterPalletsProduced1
                    }
                    helperText={
                      touched.butterPalletsProduced1 &&
                      errors.butterPalletsProduced1
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterProductProduced1'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterProductProduced1}
                    error={
                      touched.butterProductProduced1 &&
                      !!errors.butterProductProduced1
                    }
                    helperText={
                      touched.butterProductProduced1 &&
                      errors.butterProductProduced1
                    }
                  />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterPalletsProduced2'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) =>
                      calTotalButterPallets(e, values, setValues)
                    }
                    value={values.butterPalletsProduced2}
                    error={
                      touched.butterPalletsProduced2 &&
                      !!errors.butterPalletsProduced2
                    }
                    helperText={
                      touched.butterPalletsProduced2 &&
                      errors.butterPalletsProduced2
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterProductProduced2'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterProductProduced2}
                    error={
                      touched.butterProductProduced2 &&
                      !!errors.butterProductProduced2
                    }
                    helperText={
                      touched.butterProductProduced2 &&
                      errors.butterProductProduced2
                    }
                  />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterPalletsProduced3'
                    type='number'
                    disabled={recordLock}
                    onChange={(e) =>
                      calTotalButterPallets(e, values, setValues)
                    }
                    value={values.butterPalletsProduced3}
                    error={
                      touched.butterPalletsProduced3 &&
                      !!errors.butterPalletsProduced3
                    }
                    helperText={
                      touched.butterPalletsProduced3 &&
                      errors.butterPalletsProduced3
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterProductProduced3'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterProductProduced3}
                    error={
                      touched.butterProductProduced3 &&
                      !!errors.butterProductProduced3
                    }
                    helperText={
                      touched.butterProductProduced3 &&
                      errors.butterProductProduced3
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Total Pallets Produced
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterTotalPalletsProduced'
                    disabled={true}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterTotalPalletsProduced}
                    error={
                      touched.butterTotalPalletsProduced &&
                      !!errors.butterTotalPalletsProduced
                    }
                    helperText={
                      touched.butterTotalPalletsProduced &&
                      errors.butterTotalPalletsProduced
                    }
                  />
                </Grid>
                <Grid item xs={5}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Number of Boxes Out of Spec
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='butterBoxesOutOfSpec'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.butterBoxesOutOfSpec}
                    error={
                      touched.butterBoxesOutOfSpec &&
                      !!errors.butterBoxesOutOfSpec
                    }
                    helperText={
                      touched.butterBoxesOutOfSpec &&
                      errors.butterBoxesOutOfSpec
                    }
                  />
                </Grid>
              </Grid>
              <ActionBar
                id={id}
                editOnly={true}
                values={values}
                setValues={setValues}
                record='supermidwet'
                newToolTip='New Super Mid Wet Passdown'
              />
            </Form>
          </>
        )}
      </Formik>
    </>
  )
}

export default SuperMidWet
